<app-feature-tiles-grid
  *ngIf="installationDetailsStore.getSelectedGateway$ | async as gateway"
  id="installation-panels"
  cdkDropListGroup
>
  <ng-container *ngFor="let panel of panels; trackBy: trackBy">
    <!-- System Panel -->
    <ng-container [ngSwitch]="panel.panel">
      <ng-container *ngSwitchCase="panelTypes.System">
        <div
          *ngIf="(isSystemPanelVisible$ | async) && (devicesStore.isCommonDevice$ | async)"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerial"
            [panel]="panelTypes.System"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-cascade-system-tile
          >
            <app-system-v2-cascade data-at-tile="system"></app-system-v2-cascade>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Gateway Panel -->
      <ng-container *ngSwitchCase="panelTypes.CommunicationModule">
        <div
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerial"
            [panel]="panelTypes.CommunicationModule"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-v2-cascade-gateway-tile
          >
            <app-gateway-features-panel
              data-at-tile="gateway"
              [gatewaySerial]="gateway?.serial"
              [installationId]="installationId"
              [isLegacyDevice]="isLegacyDevice"
            ></app-gateway-features-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Battery overall -->
      <ng-container *ngSwitchCase="panelTypes.BatteryOverall">
        <ng-container
          *ngIf="
            (powerConsolidated$ | async | ready) ||
            (stateOfChargeConsolidated$ | async | ready) ||
            (power$ | async | ready) ||
            (stateOfCharge$ | async | ready)
          "
        >
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerial"
              [panel]="panelTypes.BatteryOverall"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-v2-cascade-battery-overall-tile
            >
              <app-battery-overall
                data-at-tile="battery-overall"
                [gatewaySerial]="gateway?.serial"
                [installationId]="installationId"
              ></app-battery-overall>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Photovoltaic overall -->
      <ng-container *ngSwitchCase="panelTypes.PhotovoltaicOverall">
        <ng-container *ngIf="productionCurrentConsolidated$ | async | ready">
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerial"
              [panel]="panelTypes.PhotovoltaicOverall"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-v2-cascade-photovoltaic-overall-tile
            >
              <app-photovoltaic-overall
                data-at-tile="photovoltaic"
                [gatewaySerial]="gateway?.serial"
                [installationId]="installationId"
              ></app-photovoltaic-overall>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Notification Tile -->
      <ng-container *ngSwitchCase="panelTypes.NotificationTile">
        <div
          *ngIf="(gatewayStatus$ | async)?.offline && (devicesStore.isCommonDevice$ | async)"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerial"
            data-at-v2-cascade-notification-tile
          >
            <app-notification-tile
              data-at-tile="notification"
              [lastStatusChanged]="gateway?.lastStatusChangedAt"
            ></app-notification-tile>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Single Room Control -->
      <ng-container *ngSwitchCase="panelTypes.SingleRoomControl">
        <div
          *ngIf="rooms$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerial"
            [panel]="panelTypes.SingleRoomControl"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-v2-cascade-src-tile
          >
            <app-single-room-control
              data-at-tile="src"
              [installationId]="installationId"
              [gatewaySerial]="gatewaySerial"
            ></app-single-room-control>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="panelTypes.ViCarePlans">
        <ng-container
          *ngIf="
            (installationDetailsStore.isViCarePlansVisible$ | async) &&
            (devicesStore.isCommonDevice$ | async)
          "
        >
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerial"
              [panel]="panelTypes.ViCarePlans"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-v2-cascade-vicare-plans-tile
            >
              <app-vicare-plans data-at-tile="vicare-plans"></app-vicare-plans>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</app-feature-tiles-grid>

<ng-container *ngIf="devicesStore.devicesOfV2Cascade$ | async as devices">
  <ng-container *ngFor="let device of devices; index as index; trackBy: v2DeviceTrackBy">
    <ng-container *ngIf="device.deviceType !== deviceType.IndoorUnit">
      <app-v2-device-feature-tiles [device]="device" [cascadeIndex]="index">
      </app-v2-device-feature-tiles>
    </ng-container>
  </ng-container>
</ng-container>
